const createVisibilityDirective = isDesktop => {
  let updateVisibility

  return {
    beforeMount(el, binding, vnode) {
      updateVisibility = () => {
        const isMobileBreakpoint =
          vnode?.appContext?.config?.globalProperties?.$vuetify?.breakpoint
            ?.mobile
        el.style.display = isMobileBreakpoint === !isDesktop ? '' : 'none'
      }

      updateVisibility()
      window.addEventListener('resize', updateVisibility)
    },
    beforeUnmount() {
      window.removeEventListener('resize', updateVisibility)
    },
  }
}

export const mobile = createVisibilityDirective(false)
export const desktop = createVisibilityDirective(true)
